#import "../fragments/inbox-channel-fragment.graphql"

fragment InboxMessageFragment on Message {
    id
    status
    thread {
        id
        externalChannel {
            ...InboxChannelFragment
        }
    }
    isOutbound
    content
    senderEmailAddress {
        address
        display
        formatted
    }
    isNutshellSystemResponse
    creatorUser {
        id
        name
        avatarUrl
        initials
    }
    scheduledTime
    readTime
    sentTime
    failedTime
    edition {
        id
        campaign {
            id
            type
            name
            editions {
                totalCount
            }
            htmlUrlPath
        }
        position
    }
    isCancelable
    reaction
    errorReason
    mediaUrl
    creatorOrigin {
        id
        name
        originType
    }
    images
    submission {
        id
        submissionTime
        booking {
            id
            startTime
            additionalAttendees {
                id
                name
                emailAddresses {
                    primary {
                        value {
                            address
                        }
                    }
                }
            }
        }
        fields {
            edges {
                node {
                    id
                    label
                    isRequired
                }
                fieldValue {
                    ... on FormFieldSubmissionValueMultiple {
                        values
                    }
                    ... on FormFieldSubmissionValueSingle {
                        value
                    }
                    ... on FormFieldSubmissionValueSubfields {
                        subfieldValues {
                            name
                            value
                            label
                        }
                    }
                }
            }
        }
    }
}
